import React from "react";
import "./NewsCard.css";

const NewsCard = ({ title, author, subtitle, date, img }) => {
  return (
    <>
      <div className="card-body">
        <div>
          <img src={img} alt={title} />
        </div>
        <div className="card-content">
          <h1 className="title card-title">{title}</h1>
          <p className="author">
            {author} - {date}
          </p>
          <p className="subtitle card-subtitle">{subtitle}</p>
          <div className="button">Read More</div>
        </div>
      </div>
    </>
  );
};

export default NewsCard;
